export const isThrottlingActive = (monthlyThreshold: number): boolean => monthlyThreshold > 1000
